import Handlebars from 'handlebars';

/** Only text templates may reach the compiler; never accept a deserialized AST. */
export function renderEmailTemplate(template: unknown, context: object): string {
  if (typeof template !== 'string') {
    throw new TypeError('Email template must be a string');
  }
  if (!template.includes('{{')) return template;
  return Handlebars.compile(template)(context, {
    allowProtoMethodsByDefault: false,
    allowProtoPropertiesByDefault: false,
  });
}
